<template>
	<!-- Course Selection (Own Program Only) -->
	<v-container class="toggle animated" v-show="level === 1" fluid>
		<div class="d-flex flex-column flex-md-row justify-start align-left justify-md-space-between align-md-center mb-4 ga-2">
			<div class="font-weight-bold text-h6">
				{{ programTitle }}
			</div>
		</div>
		<v-row v-if="loadingCourses">
			<v-col class="d-flex justify-center mt-8">
				<v-progress-circular indeterminate color="primary" size="40"></v-progress-circular>
			</v-col>
		</v-row>
		<v-row v-else-if="courses.length === 0">
			<v-col class="d-flex justify-center mt-8">
				<v-card align="center" elevation="0">
					<v-icon size="120">mdi-book-open-blank-variant-outline</v-icon>
					<v-card-text class="text-button">No Courses Found for your Program.</v-card-text>
				</v-card>
			</v-col>
		</v-row>
		<div v-else>
			<v-row>
				<v-col cols="12" md="5">
					<v-text-field
						v-model="search"
						variant="outlined"
						prepend-inner-icon="mdi-magnify"
						label="Search"
						density="comfortable"
						hide-details
						rounded="lg"
						color="primary">
					</v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col v-for="course in filteredCourses" :key="course.id" cols="12" xl="4" md="4">
					<v-card @click="selectCourse(course)" class="pa-2 d-flex flex-column fill-height" elevation="3">
						<v-card-text>
							<div class="text-subtitle-1 font-weight-black">{{ course.code }}</div>
							<div class="text-body-2 text-grey-darken-1 mt-1">{{ course.title }}</div>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</div>
	</v-container>

	<!-- Course Outcomes -->
	<v-container class="toggle animated" v-show="level === 2" fluid>
		<div class="d-flex flex-column flex-md-row justify-start align-left justify-md-space-between align-md-center mb-4 ga-2">
			<v-btn
				prepend-icon="mdi-chevron-left"
				@click="level = 1"
				class="rounded-lg"
				color="grey-darken-1"
				height="40px"
				elevation="2">
				Back
			</v-btn>
			<div class="font-weight-bold text-h6">
				{{ cloPageTitle }}
			</div>
		</div>
		<CourseOutcomesDetails ref="CourseOutcomesDetails" />
	</v-container>
</template>

<script>
import { defineComponent } from 'vue'
import CourseOutcomesDetails from '../Sub-Parent/CourseOutcomesDetails.vue'

export default defineComponent({
	components: {
		CourseOutcomesDetails,
	},
	data() {
		return {
			level: 1,
			loadingCourses: false,
			search: null,
			courses: [],
			selectedCourse: null,
			selectedProgram: null,
		}
	},
	computed: {
		filteredCourses() {
			if (!this.search) return this.courses

			const query = this.search.toLowerCase().trim()
			return this.courses.filter(course => {
				const code = (course.code || '').toLowerCase()
				const title = (course.title || '').toLowerCase()
				return code.includes(query) || title.includes(query)
			})
		},
		programTitle() {
			if (!this.selectedProgram) return 'Course Outcomes'
			return this.selectedProgram.abbrev + ' - Course Outcomes'
		},
		cloPageTitle() {
			if (!this.selectedCourse || !this.selectedProgram) return ''
			return this.selectedProgram.abbrev + ' - ' + this.selectedCourse.code + ' Course Learning Outcomes'
		}
	},
	methods: {
		async init() {
			this.selectedProgram = this.$store.state.user.program
			this.loadingCourses = true
			this.search = null
			this.courses = []

			const programId = this.$store.state.user.program?.id
			if (!programId) {
				this.loadingCourses = false
				return
			}

			let res = await this.axiosCall('/course/findAllActiveCourseByProgram/' + programId, 'get', null, true)
			if (res && res.data) {
				this.courses = res.data
			}
			this.loadingCourses = false
		},
		selectCourse(course) {
			this.selectedCourse = course
			this.level = 2
			this.$nextTick(() => {
				this.$refs.CourseOutcomesDetails.initData(course, this.selectedProgram)
			})
		},
	},
	mounted() {
		this.init()
	},
})
</script>

<style scoped>
</style>
